import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles, createTheme, ThemeProvider } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import { MoreVert, Replay } from "@material-ui/icons";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import TicketOptionsMenu from "../TicketOptionsMenu";
import ButtonWithSpinner from "../ButtonWithSpinner";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import UndoRoundedIcon from '@material-ui/icons/UndoRounded';
import Tooltip from '@material-ui/core/Tooltip';
import { green } from '@material-ui/core/colors';


const useStyles = makeStyles(theme => ({
	actionButtons: {
		marginRight: 6,
		flex: "none",
		alignSelf: "center",
		marginLeft: "auto",
		"& > *": {
			margin: theme.spacing(0.5),
		},
	},
}));

const TicketActionButtonsCustomDynamics = ({ ticket }) => {
	const classes = useStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = useState(null);
	const [loading, setLoading] = useState(false);
	const ticketOptionsMenuOpen = Boolean(anchorEl);
	const { user } = useContext(AuthContext);
	const { setCurrentTicket } = useContext(TicketsContext);

	const customTheme = createTheme({
		palette: {
		  	primary: green,
		}
	});

	const handleOpenTicketOptionsMenu = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleCloseTicketOptionsMenu = e => {
		setAnchorEl(null);
	};

	const handleUpdateTicketStatus = async (e, status, userId) => {
		setLoading(true);
		try {
			await api.put(`/tickets/${ticket.id}`, {
				status: status,
				userId: userId || null,
				useIntegration: status === "closed" ? false : ticket.useIntegration,
				promptId: status === "closed" ? false : ticket.promptId,
				integrationId: status === "closed" ? false : ticket.integrationId
			});
			// await api.put(`/tickets/${ticket.id}`, {
			// 	status: status,
			// 	userId: userId || null,
			// 	useIntegration: status === "closed" ? false : ticket.useIntegration,
			// 	promptId: status === "closed" ? false : ticket.promptId,
			// 	integrationId: status === "closed" ? false : ticket.integrationId
			// });

			setLoading(false);

			if (status === "open") {
				setCurrentTicket({ ...ticket, code: "#open" });
				let create_redirectuuid = localStorage.getItem("ticket_uuid")
				history.push(`/dynamics/${create_redirectuuid}`);			
			} else {
				setCurrentTicket({ id: null, code: null })
				// history.push("/tickets");
				let create_redirectuuid = localStorage.getItem("ticket_uuid")
				history.push(`/dynamics/${create_redirectuuid}`);
				// history.push("/");
			}

			setTimeout(() => {
				api.post("/api/iframe_action", { action: "CLOSE_IFRAME" })
				.then(() => {
					console.log("Ação enviada para o backend da aplicação.");
				})
				.catch((error) => {
					console.error("Erro ao enviar a ação para o backend:", error);
				});
				// window.top.postMessage({ action: "CLOSE_IFRAME" }, "https://orgcd82df8b.crm2.dynamics.com");
				console.log("Mensagem enviada para fechar o iframe API.");
			}, 1000); // Adiciona atraso para garantir que o listener esteja pronto
			
			
		} catch (err) {
			setLoading(false);
			toastError(err);
			console.log("ver erro no ticket2 quando tenta abrir o ticket novamente");
		}
	};

	return (
		<div className={classes.actionButtons}>
			{ticket.status === "closed" && (
				<ButtonWithSpinner
					loading={loading}
					startIcon={<Replay />}
					size="small"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{i18n.t("messagesList.header.buttons.reopen")}
				</ButtonWithSpinner>
			)}
			{ticket.status === "open" && (
				<>
					<ThemeProvider theme={customTheme}>
						<Tooltip title={i18n.t("messagesList.header.buttons.resolve")}>
							<IconButton onClick={e => handleUpdateTicketStatus(e, "closed", user?.id)} color="primary">
								<CheckCircleIcon />
							</IconButton>
						</Tooltip>
					</ThemeProvider>
				</>
			)}
			{ticket.status === "pending" && (
				<ButtonWithSpinner
					loading={loading}
					size="small"
					variant="contained"
					color="primary"
					onClick={e => handleUpdateTicketStatus(e, "open", user?.id)}
				>
					{i18n.t("messagesList.header.buttons.accept")}
				</ButtonWithSpinner>
			)}
		</div>
	);
};

export default TicketActionButtonsCustomDynamics;
